import React, { useState, useEffect, useRef } from "react"
import { _Api } from "../api/_call";
import { Link, useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SocialModal from "../common/modules/SocialModal/SocialModal";
import { Pagination } from "../common/Pagination";
import { reportvendorpurchaselisthead } from "../common/Tablehead";
import TableColumnModal from "../common/modules/tableColumn";
import { Tablehead } from "../common/modules/Tablehead";
import { useReportSort } from "./useReportSort";
import { toFormatPrice, toUnformatPrice } from "../common/helpers/function";
import "./report.scss";
import { loading, Updateloading } from "../common/helpers/toastify";
import { useTranslation } from 'react-i18next';
import * as FileSaver from 'file-saver';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import Select from "react-select";
const VendorPurchase = (props) => {
  const { t } = useTranslation();
  const { state: locationState } = useLocation();
  const base_url_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const stickyTopRef = useRef(null);
  const tableHeadScrollRef = useRef(null);
  const tableBodyScrollRef = useRef(null);
  const tableHeadTableRef = useRef(null);
  const tableBodyTableRef = useRef(null);
  const tableScrollSyncLock = useRef(false);
  const [socialurl, setSocialurl] = useState();
  const [filtername, setFiltername] = useState('');
  const [limit, setLimit] = useState(100);
  const [newcolumndata, setnewcolumndata] = useState(reportvendorpurchaselisthead);
  const [datefilter, setDatefilter] = useState(() => {
    const start = new Date(); start.setDate(start.getDate() - 30); start.setHours(0, 0, 0, 0); return [start, new Date()];
  });
  const [datelable, setDatelable] = useState('LastMonth')
  const datePickerRef = useRef(null)
  const changeDates = (lable) => {
    const MainDate = new Date();
    if (lable === 'Today') { const s = new Date(); s.setHours(0,0,0,0); setDatefilter([s, new Date()]); setDatelable('Today'); }
    else if (lable === 'Yesterday') { const s = new Date(MainDate.setDate(MainDate.getDate()-1)); s.setHours(0,0,0,0); const e = new Date(s); e.setHours(23,59,59,999); setDatefilter([s,e]); setDatelable('Yesterday'); }
    else if (lable === '7days') { const s = new Date(MainDate.setDate(MainDate.getDate()-7)); s.setHours(0,0,0,0); const e = new Date(); e.setHours(23,59,59,999); setDatefilter([s,e]); setDatelable('7days'); }
    else if (lable === '30days') { const s = new Date(MainDate.setDate(MainDate.getDate()-30)); s.setHours(0,0,0,0); const e = new Date(); e.setHours(23,59,59,999); setDatefilter([s,e]); setDatelable('30days'); }
    else if (lable === 'ThisMonth') { const s = new Date(MainDate.getFullYear(),MainDate.getMonth(),1); s.setHours(0,0,0,0); const e = new Date(MainDate.getFullYear(),MainDate.getMonth()+1,0); e.setHours(23,59,59,999); setDatefilter([s,e]); setDatelable('ThisMonth'); }
    else if (lable === 'LastMonth') { const s = new Date(); s.setDate(s.getDate()-30); s.setHours(0,0,0,0); setDatefilter([s, new Date()]); setDatelable('LastMonth'); }
  }
  const [vendorpurchaselist, setVendorpurchaselist] = useState([]);
  const reportSort = useReportSort(vendorpurchaselist, [null, (r) => r?.date, (r) => r?.pu_no, (r) => r?.shipto, (r) => r?.qty, (r) => r?.amount]);
  const [shareloader, setShareloader] = useState(false);
  const [location, setLoccation] = useState()
  const [name, setName] = useState()
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [datalodaer, setDatsLodaer] = useState(false)
  const [state, setstate] = useState({
    totalPages: 0,
    currentPage: 1,
  });
  const { totalPages, currentPage } = state;
  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    getvendorpurchase(1, limit, search);
  }
  const getlimit = (nextLimit) => {
    setLimit(nextLimit);
    getvendorpurchase(1, nextLimit);
    setstate({ ...state, currentPage: 1 });
  };
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    getvendorpurchase(current, "");
  };
  useEffect(() => {
    callcolumns();
  }, []);
  const getsharevendorpurchase = async () => {
    setShareloader(true);
    try {
      const postdata = {
        "supplier_id": locationState ? locationState?.vendor_id : "",
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : ""
      };
      let res = await _Api(postdata, `api/v1/Inventory/reports/print/vendorPU`);

      if (res.code === 200) {
        setSocialurl(res?.link);
        setShareloader(false);
      }
    }
    catch (err) {
      console.log(err, 'err');
    }

  }
  const getprintvendorpurchase = async () => {
    let GetloadingID = loading();
    try {
      const postdata = {
        "supplier_id": locationState ? locationState?.vendor_id : "",
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : ""
      }
      let res = await _Api(postdata, `api/v1/Inventory/reports/print/vendorPU`);
      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement('a');
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute('target', '_blank');
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));

        }, 50)
        setSocialurl(res?.link);
      } else {
        Updateloading(t, GetloadingID, res?.message ? (res?.message) : (res?.errors), 'error');
      }
    }
    catch (err) {
      console.log(err, 'err');
      Updateloading(t, GetloadingID, err, t('error'));
    }

  }

  const getvendorpurchase = async (current, firstlimit, search) => {
    setDatsLodaer(true)
    const tablelimit = firstlimit ? firstlimit : limit;
    const skipNumber = current ? (current - 1) * (Number(tablelimit) || 0) : 0;
    try {
      const postdata = {
        "search": search === "" ? search : (search || filtername || ""),
        "limit": firstlimit ? firstlimit : limit,
        "skip": skipNumber,
        "start_date": datefilter ? datefilter[0] : "",
        "end_date": datefilter ? datefilter[1] : "",
        "vendorId": locationState ? locationState?.vendor_id : ''
      };
      let res = await _Api(postdata, `api/v1/Inventory/report/vendorPurchase`);
      if (res.code === 200) {
        const rows = res?.data || [];
        const page = current ? Number(current) : 1;
        const pageini = Number(postdata.limit) || rows.length || 1;
        const hasApiTotal = res?.total !== undefined && res?.total !== null && res?.total !== "";
        setVendorpurchaselist(rows);
        setLoccation(res?.location)
        setName(res?.name)
        if (!rows.length && page > 1 && !hasApiTotal) {
          setstate((prev) => ({
            ...prev,
            totalPages: page - 1,
            currentPage: page - 1,
          }));
        } else {
          setstate((prev) => {
            let totalPages = 0;
            if (hasApiTotal) {
              totalPages = Math.ceil((Number(res?.total) || 0) / pageini) || 0;
            } else if (!rows.length) {
              totalPages = 0;
            } else if (rows.length < pageini) {
              totalPages = page;
            } else if (page === 1) {
              totalPages = 2;
            } else {
              totalPages = Math.max(prev.totalPages || 0, page + 1);
            }
            return { ...prev, totalPages, currentPage: page };
          });
        }

      } else {
        // "data not found" -> nothing in this range; clear the old rows
        setVendorpurchaselist([]);
        setstate((prev) => ({ ...prev, totalPages: 0, currentPage: 1 }));
      }
      setDatsLodaer(false)
    }
    catch (err) {
      setDatsLodaer(false);
      console.log(err, 'err');
    }
  }
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "vendor_purchase_table",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (datefilter[0] && datefilter[1]) {
      getvendorpurchase();
    }
    // eslint-disable-next-line
  }, [datefilter]);

  useEffect(() => {
    const el = stickyTopRef.current;
    if (!el) return undefined;
    const page = el.closest(".vendor-purchase-page");
    const apply = () => {
      if (!page) return;
      page.style.setProperty(
        "--report-sticky-block-height",
        `${el.offsetHeight}px`,
      );
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, []);

  const syncVendorPurchaseTableScroll = (source) => {
    if (tableScrollSyncLock.current) return;
    const head = tableHeadScrollRef.current;
    const body = tableBodyScrollRef.current;
    if (!head || !body) return;
    tableScrollSyncLock.current = true;
    if (source === "head") {
      body.scrollLeft = head.scrollLeft;
    } else {
      head.scrollLeft = body.scrollLeft;
    }
    requestAnimationFrame(() => {
      tableScrollSyncLock.current = false;
    });
  };

  useEffect(() => {
    let frame = 0;
    const syncVendorPurchaseTableWidths = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const headTable = tableHeadTableRef.current;
        const bodyTable = tableBodyTableRef.current;
        if (!headTable || !bodyTable) return;

        const headThs = headTable.querySelectorAll("thead th");
        const bodyRow = bodyTable.querySelector("tbody tr");
        const count = headThs.length;
        if (!count) return;

        headTable.style.width = "max-content";
        bodyTable.style.width = "max-content";
        headTable.style.tableLayout = "auto";
        bodyTable.style.tableLayout = "auto";
        headThs.forEach((th) => {
          th.style.width = "";
          th.style.minWidth = "";
          th.style.maxWidth = "";
        });
        bodyTable.querySelectorAll("td, th").forEach((cell) => {
          cell.style.width = "";
          cell.style.minWidth = "";
          cell.style.maxWidth = "";
        });

        const widths = [];
        for (let i = 0; i < count; i += 1) {
          const hw = headThs[i].getBoundingClientRect().width;
          const bw = bodyRow?.children[i]?.getBoundingClientRect().width || 0;
          widths.push(Math.ceil(Math.max(hw, bw, 40)));
        }
        let total = widths.reduce((sum, w) => sum + w, 0);
        const containerWidth = Math.floor(
          tableBodyScrollRef.current?.clientWidth ||
            tableHeadScrollRef.current?.clientWidth ||
            0,
        );
        if (containerWidth > total && total > 0) {
          const scale = containerWidth / total;
          let used = 0;
          for (let i = 0; i < count; i += 1) {
            if (i === count - 1) {
              widths[i] = Math.max(widths[i], containerWidth - used);
            } else {
              widths[i] = Math.max(1, Math.floor(widths[i] * scale));
              used += widths[i];
            }
          }
          total = containerWidth;
        }
        headTable.style.tableLayout = "fixed";
        bodyTable.style.tableLayout = "fixed";
        headTable.style.width = `${total}px`;
        bodyTable.style.width = `${total}px`;

        for (let i = 0; i < count; i += 1) {
          const widthPx = `${widths[i]}px`;
          headThs[i].style.width = widthPx;
          headThs[i].style.minWidth = widthPx;
          headThs[i].style.maxWidth = widthPx;
          bodyTable
            .querySelectorAll(`tr > :nth-child(${i + 1})`)
            .forEach((cell) => {
              cell.style.width = widthPx;
              cell.style.minWidth = widthPx;
              cell.style.maxWidth = widthPx;
            });
        }

        (newcolumndata || []).forEach((col, index) => {
          const hide = col?.status === false;
          headThs[index]?.classList.toggle("d-none", hide);
          bodyTable
            .querySelectorAll(`tr > :nth-child(${index + 1})`)
            .forEach((cell) => {
              cell.classList.toggle("d-none", hide);
            });
        });
      });
    };

    syncVendorPurchaseTableWidths();
    window.addEventListener("resize", syncVendorPurchaseTableWidths);
    const observer = new ResizeObserver(syncVendorPurchaseTableWidths);
    if (tableHeadScrollRef.current) observer.observe(tableHeadScrollRef.current);
    if (tableBodyScrollRef.current) observer.observe(tableBodyScrollRef.current);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("resize", syncVendorPurchaseTableWidths);
      observer.disconnect();
    };
  }, [vendorpurchaselist, newcolumndata, datalodaer]);

  const downloadexclsheet = async () => {
    let header_values = [];
    let bodyarray = [];
    reportvendorpurchaselisthead.map(async (r, k) => {
      header_values.push(r?.lable)
    })
    if (vendorpurchaselist.length) {
      vendorpurchaselist.forEach((result, key) => {
        bodyarray.push([key + 1, result?.date, result?.pu_no, result?.shipto, result?.qty, result?.amount])
      })
    }
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(bodyarray, { origin: 'A2', skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: 'A1' });
    XLSX.utils.book_append_sheet(wb, ws, 'Records');
    const fileContent = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([fileContent], { type: fileType });
    FileSaver.saveAs(data, "report_vendor");
  }
  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]
  return (
    <React.Fragment>
      <div className="main-body report-page vendor-purchase-page product-tab-page-padding-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="sticky-top-report-page" ref={stickyTopRef}>
              <div className="top-heading-area">
                <div className="top-heading-area-left">
                  <Link to="/app/inventory/report/vendor" className="page-back-btn"><img src={base_url_assets + "images/icons/arrow-left.png"} alt="back" /></Link>
                  <h2 className="main-body-heading">{t("Vendor Report")}</h2>
                </div>
              </div>
              <div className='report-location-header'>
                <span className='report-location-header-location'>{location}</span>
                <span className='report-location-header-divider'>|</span>
                <span className='report-location-header-location-sub'> {name}</span>
              </div>
              <div className="main-body-top-tab-bar create-purchase-top-bar">
                <div
                  className="main-body-top-tab-bar-left-col nav nav-pills"
                  role="tablist"
                >
                  <Link to="/app/inventory/report/vendorPurchaseOrder"
                    state={{ vendor_id: locationState?.vendor_id }}
                    className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"

                  >
                    <span className="main-body-top-tab-bar-left-col-a-text">
                      <img
                        className="tab-hover-img-1"
                        src={base_url_assets + "images/icons/price-list-icon.png"}
                        alt=""
                      />
                      <img
                        className="tab-hover-img-2"
                        src={base_url_assets + "images/icons/price-list-icon-green.png"}
                        alt=""
                      />
                      {t("Purchase Order")}
                    </span>
                  </Link>
                  <Link to=""
                    className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh active"

                  >
                    <span className="main-body-top-tab-bar-left-col-a-text">
                      <img
                        className="tab-hover-img-1"
                        src={base_url_assets + "images/icons/replenish-icon.png"}
                        alt=""
                      />
                      <img
                        className="tab-hover-img-2"
                        src={base_url_assets + "images/icons/replenish-icon-green.png"}
                        alt=""
                      />
                      {t("Purchase")}
                    </span>
                  </Link>
                </div>
              </div>
                  <div className="main-body-top-status-bar">
                    <Select
                      className="limit-select short z-10"
                      options={selectOptions}
                      value={{ label: limit, value: limit }}
                      onChange={(e) => {
                        setLimit(e.value);
                        getlimit(e.value);
                      }}
                    />
                    <div className="main-body-top-status-bar-filter">
                      <input
                        value={filtername}
                        type="text"
                        className="main-body-top-status-bar-filter-input"
                        placeholder={t("Search by SKU, Stock ID, Customer")}
                        onKeyPress={(e) => e.key === 'Enter' && filterbyname(e.target.value)}
                        onChange={(e) => setFiltername(e.target.value)}
                      />
                      {filtername ? <img className="main-body-top-status-bar-filter-clear" src={base_url_assets + 'images/icons/False.png'} onClick={(e) => { setFiltername(""); filterbyname("") }} alt="" /> : ""}
                      <button onClick={() => filterbyname(filtername)} className="main-body-top-status-bar-filter-search">
                        <i className="fa fa-search" aria-hidden="true" />
                      </button>
                    </div>
                    <div className="main-body-top-status-bar-multi-date-picker">
                      <div className="main-body-top-status-bar-note-button common-dropdown replenish-date">
                        <button className="dropdown-toggle btn-style align-items-center d-flex" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 4.66667V8L10.5 10.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          {t(datelable)}
                        </button>
                        <ul className="dropdown-menu dropdown-menu-right-fix">
                          <li className={`dropdown-item ${datelable === 'Today' ? "active" : ""}`} onClick={() => changeDates('Today')}>{t("Today")}</li>
                          <li className={`dropdown-item ${datelable === 'Yesterday' ? "active" : ""}`} onClick={() => changeDates('Yesterday')}>{t("Yesterday")}</li>
                          <li className={`dropdown-item ${datelable === '7days' ? "active" : ""}`} onClick={() => changeDates('7days')}>{t("Last 7 days")}</li>
                          <li className={`dropdown-item ${datelable === '30days' ? "active" : ""}`} onClick={() => changeDates('30days')}>{t("Last 30 days")}</li>
                          <li className={`dropdown-item ${datelable === 'ThisMonth' ? "active" : ""}`} onClick={() => changeDates('ThisMonth')}>{t("This Month")}</li>
                          <li className={`dropdown-item ${datelable === 'LastMonth' ? "active" : ""}`} onClick={() => changeDates('LastMonth')}>{t("Last Month")}</li>
                          <li className={`dropdown-item ${datelable === 'Custom Range' ? "active" : ""}`} onClick={() => datePickerRef.current.setOpen(true)}>{t("Custom Range")}</li>
                        </ul>
                        <DatePicker selectsRange={true} monthsShown={2} startDate={datefilter[0]} endDate={datefilter[1]} onChange={(update) => { const s=update[0],e=update[1]; setDatelable("Custom Range"); if(s&&e){const ms=new Date(s);ms.setHours(0,0,0,0);const me=new Date(e);me.setHours(23,59,59,999);setDatefilter([ms,me]);}else{setDatefilter([s,e]);} }} dateFormat="yyyy-MM-dd" ref={datePickerRef} autoComplete='none' />
                      </div>
                      <button className="print-export-dropdown-selected-icon d-none">
                        <img
                          src={base_url_assets + "images/icons/printer-icon.png"}
                          alt=""
                        />
                      </button>
                      <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {" "}
                          <img
                            src={base_url_assets + "images/icons/ellipsis-circular.png"}
                            alt=""
                          />{" "}
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li className={parmissiondatashow?.inventory_reports?.Print ? "dropdown-item print-dropdown-item" : "d-none"} onClick={(e) => { getprintvendorpurchase(e.target.value); }}>
                            <div className="dropdown-item-img">
                              <img
                                src={base_url_assets + "images/icons/printer-icon.png"}
                                alt=""
                              />
                            </div>
                            <span>{t("print")}</span>
                          </li>
                          <li className="dropdown-item" onClick={(e) => { downloadexclsheet(e.target.value); }}>
                            <div className="dropdown-item-img">
                              <img
                                src={base_url_assets + "images/icons/export-x-icon.png"}
                                alt=""
                              />
                            </div>
                            <span>{t("export")}</span>
                          </li>

                          <li className="dropdown-item" data-bs-toggle="modal" data-bs-target="#socialModal" onClick={() => getsharevendorpurchase()}>
                            <div className="dropdown-item-img">
                              <img
                                src={base_url_assets + "images/icons/share-icon.png"}
                                alt=""
                              />
                            </div>
                            <span >{t("share")}</span>
                          </li>

                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#columnModal"
                          >
                            <div className="dropdown-item-img">
                              <img
                                src={base_url_assets + "images/icons/column-icon.png"}
                                alt=""
                              />
                            </div>
                            <span>{t("column")}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
              </div>
              <div className="tab-content">
                <div id="replenish_order" className="tab-pane active">
                  <div className="common-sub-table-wrap add-row">
                    <div
                      className="main-body-main-table-wrap position-relative report-sticky-table-wrap"
                      style={{
                        maxWidth: "100%",
                        width: "100%",
                        overflow: "visible",
                      }}
                    >
                      <div className="report-sticky-thead">
                        <div
                          className="report-table-hscroll report-table-hscroll--head"
                          ref={tableHeadScrollRef}
                          onScroll={() => syncVendorPurchaseTableScroll("head")}
                        >
                          <table
                            ref={tableHeadTableRef}
                            className="stripe row-border order-column common-table table-striped main-table report-head-table"
                          >
                            <Tablehead
                              tablehead={newcolumndata}
                              tblName={"tbl_report_vendorpurchase"}
                              setfilterby={""}

                              onSort={reportSort.handleSort}

                              sortConfig={reportSort.sortConfig}
                            />
                          </table>
                        </div>
                      </div>
                      <div
                        className="report-table-hscroll report-table-hscroll--body"
                        ref={tableBodyScrollRef}
                        onScroll={() => syncVendorPurchaseTableScroll("body")}
                      >
                        <table
                          id="vendor_purchase_table"
                          ref={tableBodyTableRef}
                          className="stripe row-border order-column common-table table-striped main-table w-100"
                        >
                          <tbody>
                            <>
                              {vendorpurchaselist ? reportSort.sortedList.map((result, key) => {
                                return (
                                  <tr className="" key={key}>
                                    <td className="fixed-side">{(currentPage - 1) * (Number(limit) || 0) + key + 1}</td>
                                    <td className="fixed-side">{result?.date ? result?.date : ''}</td>
                                    <td className="fixed-side link-color">{result?.pu_no ? result?.pu_no : ''}</td>
                                    <td className="fixed-side">{result?.shipto ? result?.shipto : ''}</td>
                                    <td className="fixed-side">{result?.qty ? result?.qty : ''}</td>
                                    <td className="fixed-side">{result?.amount ? result?.amount : ''}</td>
                                  </tr>
                                );
                              }) : ''}
                            </>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td />
                              <td />
                              <td />
                              <td />
                              <td >{vendorpurchaselist
                                ? vendorpurchaselist?.reduce(
                                  (interation, val) =>
                                  (interation =
                                    interation + parseInt(val.qty)),
                                  0
                                )
                                : ""}</td>
                              <td >{
                                toFormatPrice(vendorpurchaselist
                                  ? vendorpurchaselist?.reduce(
                                    (interation, val) =>
                                    (interation =
                                      interation +
                                      toUnformatPrice(val?.amount)),
                                    0
                                  )
                                  : "", { addSymbol: true })
                              }</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                      <div id="table_loader" className={datalodaer ? "mt-4" : "d-none"}>
                        <div className="dots">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                    </div>
                    {vendorpurchaselist?.length > 0 ? (
                      <Pagination
                        total={totalPages}
                        current={currentPage}
                        pagination={(crPage) => handlePaginations(crPage)}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SocialModal shareUrl={socialurl} shareloader={shareloader} />
      </div>
      <TableColumnModal tablehead={reportvendorpurchaselisthead} tblName={"tbl_report_vendorpurchase"} setnewcolumndata={setnewcolumndata} calldatatable={getvendorpurchase}  ></TableColumnModal>
    </React.Fragment>
  );


}

export default VendorPurchase;